import logo from './logo.svg';
import './App.css';
import { Home } from './components/home';
import {anime} from "react-anime"

function App() {
  return (
    <div className="App" id='c'>
      
      <Home/>
    </div>
  );
  

  
}


export default App;
